<script>
    import userService from '../user/service.svelte.js';
    import { notificate } from '../../services/notification.js';
    import { translateErrorMessages } from '../../services/api.svelte.js';
    import { form as svForm, field } from "svelte-forms";
    import { required } from 'svelte-forms/validators';
    import integrationService from './service.js';
    import { removeTags } from '../../js/utils.js';
    import ipaddr from 'ipaddr.js';
    import { format } from 'svelte-i18n';

    let { integration, onsave, oncancel } = $props();

    let formDataPromise = $state();
    let formData = $state({});
    let formIsSubmitted = $state(false);
    let APIerror = $state(null);
    let formApiErrors = $state({});
    let showformApiErrors = $state(false);
    let is_editing = $state(false);

    const nameField = field('name', '', [required()]);
    const roleField = field('role', integration ? integration.role : "operator", [required()]);
    const myForm = svForm(nameField);

    if (!integration) {
        formDataPromise = Promise.resolve(formData = {});
    } else {
        is_editing = true;
        formData = { name: integration.name, id: integration.id, role: integration.role };
        nameField.set(formData.name);
        roleField.set(formData.role);
        formDataPromise = Promise.resolve(formData);
    }

    function shouldShowFieldError(field) {
        return (((formIsSubmitted || field.dirty) && !field.valid) || (formApiErrors[field]));
    }

    async function handleSubmit(event) {
        if (event) event.preventDefault();

        formIsSubmitted = true;
        formApiErrors = {};

        await nameField.validate();
        await roleField.validate();

        if ($myForm.hasError("name.required")) {
            notificate('422');
            return false;
        }

        formData = { name: $nameField.value, role:$roleField.value };

        for (let [k, v] of Object.entries(formData)) {
            if (typeof v == 'string') formData[k] = removeTags(v);
        }

        if (is_editing) formData.id = integration.id;

        integrationService.save(formData, [], {}, !is_editing)
            .then(savedIntegration => {
                if (onsave) onsave(savedIntegration);
                formData = {};
                formIsSubmitted = false;
                formApiErrors = {};
                return true;
            })
            .catch(errors => {
                if (typeof(errors.detail) == 'string') {
                   APIerror = translateErrorMessages(errors.detail, "integrations");
                } else {
                    showformApiErrors = true;
                    APIerror = errors;
                }
                return false;
            });
            
        formIsSubmitted = false;
        formApiErrors = {};
        APIerror = null;
        return true;
    }

    function handleCancel() {
        formIsSubmitted = false;
        if (oncancel) oncancel();
    }

    const handleKeydown = event => {
        if (event.key == "Escape") handleCancel();
    }
</script>

<style>
    .alert.alert-warning { color: #856404; background-color: #fff3cd; }
</style>

<svelte:window onkeydown={handleKeydown} />

<form role="form" novalidate onsubmit={handleSubmit}>
    <div class="card">
        <div class="card-body">
            {#await formDataPromise then formDataUnused}
                <div class="mb-3">
                    <label for="name">{$format("list.columns.name")}<span class="text-danger">*</span></label>
                    <input
                        type="text"
                        class="form-control t-input-integration-name"
                        id="integrationAddName"
                        name="name"
                        placeholder={$format("list.columns.name")}
                        bind:value={$nameField.value}
                        onchange={async () => await nameField.validate()}
                        class:is-invalid={shouldShowFieldError($nameField)}
                    />
                    {#if APIerror}
                        <div class="mt-3 text-danger" style="font-size: 80%;">{APIerror}</div>
                    {/if}
                    {#if shouldShowFieldError($nameField)}
                        {#if $myForm.hasError('name.required')}
                            <div class="invalid-feedback">
                                {$format("required")}
                            </div>
                        {/if}
                    {/if}
                </div>
                <div class="mb-3">
                    <label for="role">{$format("list.columns.role")}</label>
                    <select
                        id="role"
                        name="role"
                        class="t-input-user-role form-control"
                        bind:value={$roleField.value}
                    >
                    {#each Object.entries(userService.roles) as [value, label]}
                        {#if value != "administrator"}
                            <option value={value}>{$format(`page.user.roles.${value}`)}</option>
                        {/if}
                    {/each}
                    </select>
                </div>
                {#if !is_editing}
                    <div class="alert alert-warning mt-3" role="alert">
                        {$format("page.integration.save_warning")}
                    </div>
                {/if}
            {/await}
        </div>
        <div class="card-footer">
            <button id="integrationAddSubmit" type="submit" class="btn btn-primary t-submit-integration-btn">{$format("buttons.save")}</button>
            <button class="btn btn-default" type="button" onclick={handleCancel}>{$format("buttons.cancel")}</button>
        </div>
        {#await formDataPromise}
            <div class="overlay"><i class="fas fa-2x fa-sync-alt fa-spin"></i></div>
        {/await}
    </div>
</form>